var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStewartTitleGuaranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4696 9.15088L22.3926 11.2745L25.0445 16.0915H29.3332L25.4696 9.15088Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89841 9.15088L2.66699 22.8495H7.12507L14.3565 9.15088H9.89841Z",
    fill: "#AF1E3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4936 9.15088L8.3291 22.8495H12.6714L19.836 9.15088H15.4936Z",
    fill: "#AF1E3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1597 9.15088L13.9912 22.8495H18.336L25.4981 9.15088H21.1597Z",
    fill: "#AF1E3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStewartTitleGuaranty);
export default __webpack_public_path__ + "static/media/stewart-title-guaranty.63f2cf22962d72c8bfe8e11c5aa5df68.svg";
export { ForwardRef as ReactComponent };